import React from "react";

const CommonButton = ({
  label = "Click Me",
  onClick,
  type = "button",
  className = "",
  disabled = false,
  icon = null,
  variant = "primary", // example: "primary", "success", etc.
}) => {
  return (
    <button
      aria-label={label}
      type={type}
      className={`d-flex gap-2 justify-content-center align-items-center neo-btn neo-btn-${variant} ${className}`}
      onClick={onClick}
      disabled={disabled}
    >
      <div>{label}</div>
      {icon && <div className="d-flex align-items-center">{icon}</div>}
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </button>
  );
};

export default CommonButton;
